import Image from 'next/image';
import ImageAppStore from '../../../../../ui-kit/assets/app-store-badges/app-store.png';
import ImagePlayStore from '../../../../../ui-kit/assets/app-store-badges/google-play-badge.png';
import MetaNavigation from './meta-navigation';
import useMobileOs from '@tuic/lib/hooks/use-mobile-os';
import AppStoreRating from './app-store-rating';
import { EventClickElement } from '@tuic/tracking';
import { I18NFromComponent } from '../../../utils';
type Props = {
  ratings?: {
    ios?: number;
    android?: number;
  };
  title?: string;
  text?: string;
  ratingTitle?: string;
  appStoreLogoAlt?: string;
  playStoreLogoAlt?: string;
  i18n?: I18NFromComponent<typeof AppStoreRating>;
};
const renderRating = (rating: undefined | number, title?: string, i18n?: I18NFromComponent<typeof AppStoreRating>) => {
  if (!rating) {
    return null;
  }
  return <div className="mt-[0.3125rem]" data-sentry-component="renderRating" data-sentry-source-file="app-store-badges.tsx">
      {title && <p className="text-[0.75rem] leading-[normal]">{title}</p>}
      <AppStoreRating rating={rating} i18n={i18n} data-sentry-element="AppStoreRating" data-sentry-source-file="app-store-badges.tsx" />
    </div>;
};
const AppStoreBadges = ({
  ratings,
  title,
  text,
  i18n,
  ratingTitle,
  appStoreLogoAlt,
  playStoreLogoAlt
}: Props) => {
  const mobileOs = useMobileOs();
  if (!ratings) {
    return null;
  }
  const renderIos = mobileOs !== 'Android';
  const renderAndroid = mobileOs !== 'iOs';
  if (!renderIos && !renderAndroid) {
    return null;
  }
  return <div data-track-click-category="AppStoreBadges" className="text-center lg:text-left" data-sentry-component="AppStoreBadges" data-sentry-source-file="app-store-badges.tsx">
      {title && <MetaNavigation.Title className="m-0 leading-[1.25rem]">
          {title}
        </MetaNavigation.Title>}
      {text && <p className="text-[0.875rem] leading-[1.875rem] lg:mt-[0.3125rem] lg:leading-[1.125rem]">
          {text}
        </p>}

      <ul className="m-0 mt-2.5 flex list-none flex-wrap justify-center gap-2.5 p-0 lg:flex-nowrap lg:justify-between">
        {renderIos && <li>
            <a className="relative block w-[calc(46px_*_3)] pt-[calc(100%_/_3)]" href="https://apps.apple.com/de/app/mein-schiff-kreuzfahrten/id354691241" target="_blank">
              <Image data-track-click-element={EventClickElement.Logo} data-track-click-label={appStoreLogoAlt || ''} src={ImageAppStore} fill alt={appStoreLogoAlt || ''} />
            </a>

            {renderRating(ratings.ios, ratingTitle, i18n)}
          </li>}
        {renderAndroid && <li>
            <a className="relative block w-[calc(46px_*_3.365)] pt-[calc(100%_/_3.365)]" href="https://play.google.com/store/apps/details?id=com.eyet.meinschiff&gl=DE" target="_blank">
              <Image data-track-click-element={EventClickElement.Logo} data-track-click-label={playStoreLogoAlt || ''} src={ImagePlayStore} fill alt={playStoreLogoAlt || ''} />
            </a>

            {renderRating(ratings.android, ratingTitle, i18n)}
          </li>}
      </ul>
    </div>;
};
export default AppStoreBadges;